import { all } from "redux-saga/effects";
import {
  customReportValidateWatcher,
  customReportExecuteWatcher,
  customReportSaveWatcher,
  customReportListWatcher,
  customReportGetWatcher,
  customReportUpdateWatcher,
  customReportDeleteWatcher,
  customReportSchemaWatcher,
  customReportExportExcelWatcher,
  customReportExportPdfWatcher,
  customReportParseParametersWatcher,
  customReportExecuteFunctionWatcher,
  customReportSaveFunctionReportWatcher,
  customReportUpdateFunctionReportWatcher,
} from "../custom-report-saga";

export default function* customReportRootSaga() {
  yield all([
    customReportValidateWatcher(),
    customReportExecuteWatcher(),
    customReportSaveWatcher(),
    customReportListWatcher(),
    customReportGetWatcher(),
    customReportUpdateWatcher(),
    customReportDeleteWatcher(),
    customReportSchemaWatcher(),
    customReportExportExcelWatcher(),
    customReportExportPdfWatcher(),
    customReportParseParametersWatcher(),
    customReportExecuteFunctionWatcher(),
    customReportSaveFunctionReportWatcher(),
    customReportUpdateFunctionReportWatcher(),
  ]);
}
